import React, { Suspense, useRef, Component, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Environment, OrbitControls, Html, useProgress } from "@react-three/drei";
import { Scene } from './Scene'
import { OptionsMenu } from './OptionsMenu'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import * as THREE from "three";
const App = () => {
  var activeOption;
  var rotationInfo;
  const [newMaterialOpt, setNewMaterialOpt] = useState({
    activeOption,
    newMTL: null
  });

  const selectSwatch = (name) => {
    activeOption = name;
    let newMTL;
      newMTL = new THREE.MeshPhongMaterial({
        color: parseInt("0xBE1E2D"),
      });

    return setNewMaterialOpt({
      activeOption,
      newMTL
    });
  };
    return (
    <>
    <React.Fragment>
      <OptionsMenu
        activeOption={activeOption}
        selectSwatch={selectSwatch}
      />
    <Canvas id="rtfCanvas" camera={{position: [0,6,7]}}>
        <Scene newMaterialOpt={newMaterialOpt} />
      </Canvas>
    </React.Fragment>
      </>
      );
}

export default App;